import SnackabraStore from "./Snackabra.Store";
export const stores = {
    SB: SnackabraStore,
};
